module.exports = __webpack_public_path__ + "img/bujin_tiles_placeholder.c580b293.jpg";